import type { MarkersPreset } from "@/types/markers-presets"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface MarkerPresetPayload {
	name: string
	markers: string[]
}

export default {
	list() {
		return HttpClient.get<MarkersPreset[]>(`${API_ROOT}/doctors/me/markers-presets`)
	},
	create(payload: MarkerPresetPayload) {
		return HttpClient.post<MarkersPreset>(`${API_ROOT}/doctors/me/markers-presets`, payload)
	},
	update(presetId: number, payload: MarkerPresetPayload) {
		return HttpClient.put(`${API_ROOT}/doctors/me/markers-presets/${presetId}`, payload)
	},
	delete(presetId: number) {
		return HttpClient.delete(`${API_ROOT}/doctors/me/markers-presets/${presetId}`)
	}
}
